import axios from 'axios';
import api from './api';
const API_URL = 'https://api-prd.kasaka.co.zm/api/v1';

export const login = async (email: string, password: string): Promise<any> => {
  try {
    const response = await axios.post(`${API_URL}/auth/login/system_user`, { email, password });
    return response.data;
  } catch (error: any) {
    console.error('Login error:', error.message || error);
    throw new Error('Failed to log in');
  }
};

export const verify2FA = async (email: string, otp: string): Promise<any> => {
  try {
    const response = await axios.post(`${API_URL}/auth/verify_system_user_otp`, {
      email,
      otp,
      user_type: 'system_user',
    });
    return response.data;
  } catch (error: any) {
    console.error('2FA verification error:', error.message || error);
    throw new Error('Failed to verify 2FA');
  }
};

export const logout = async (): Promise<any> => {
  try {
    const response = await api.post('/auth/logout');
    return response.data;
  } catch (error: any) {
    console.error('Logout error:', error.message || error);
    throw new Error('Failed to log out');
  }
};

export const refreshTokenAPI = async (refreshToken: string): Promise<any> => {
  try {
    const response = await axios.post(`${API_URL}/auth/refresh_token`, {
      refresh_token: refreshToken,
    });
    if (response.status === 200 && response.data) {
      return response.data;
    } else {
      throw new Error('Invalid response from server');
    }
  } catch (error: any) {
    console.error('Error refreshing token:', error.message || error);
    throw new Error('Failed to refresh token');
  }
};